import { createAsyncThunk } from "@reduxjs/toolkit";

import axios from "../../../axios";

export const fetchAppointments = createAsyncThunk(
  "appointment/fetchAppointments",
  async (params = {}, { rejectWithValue }) => {
    const { appointmentStatus, limit = 10, skip = 0, pastType } = params;

    try {
      const response = await axios.get("/appointments", {
        params: {
          appointmentStatus,
          limit,
          skip,
          ...(pastType ? { pastType } : {}),
        },
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue({
        success: false,
        message: "Failed to fetch appointments",
      });
    }
  },
);

export const fetchUpcomingAppointments = (limit = 10, skip = 0) => {
  return fetchAppointments({ appointmentStatus: "UPCOMING", limit, skip });
};

export const fetchTodayAppointments = (limit = 10, skip = 0) => {
  return fetchAppointments({ appointmentStatus: "TODAY", limit, skip });
};

export const fetchCompletedAppointments = (limit = 10, skip = 0) => {
  return fetchAppointments({ appointmentStatus: "COMPLETED", limit, skip });
};

export const fetchPastAppointments = (limit = 10, skip = 0, pastType) => {
  return fetchAppointments({
    appointmentStatus: "PAST",
    limit,
    skip,
    ...(pastType ? { pastType } : {}),
  });
};

export const fetchAppointmentById = createAsyncThunk(
  "appointment/fetchAppointmentById",
  async (params = {}, { rejectWithValue }) => {
    const { appointmentId } = params;

    try {
      const response = await axios.get("/appointments/details", {
        params: { appointmentId },
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue({
        success: false,
        message: "Failed to fetch appointment",
      });
    }
  },
);

export const rescheduleAppointment = createAsyncThunk(
  "appointment/rescheduleAppointment",
  async (params = {}, { rejectWithValue }) => {
    const { appointmentId, availabilityId, topicId, originalAppointmentId } =
      params;

    try {
      const response = await axios.post("/appointments/reschedule", {
        availabilityId,
        topicId,
        originalAppointmentId: originalAppointmentId || appointmentId,
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue({
        success: false,
        message: "Failed to reschedule appointment",
      });
    }
  },
);

export const cancelAppointment = createAsyncThunk(
  "appointment/cancelAppointment",
  async (params = {}, { rejectWithValue }) => {
    const { appointmentId } = params;

    try {
      const response = await axios.post("/appointments/cancel", {
        appointmentId,
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue({
        success: false,
        message: "Failed to cancel appointment",
      });
    }
  },
);
